export const INELIGIBILITY_REASONS = Object.freeze({
  EXTERNAL_BANK_ACCOUNT_REQUIRED: 'external_bank_account_required',
  IDENTITY_VERIFICATION_REQUIRED: 'identity_verification_required',
  INELIGIBLE_PRODUCTS: 'ineligible_products',
  LOGIN_REQUIRED: 'login_required',
});

export const ISSUER_INSTALLMENTS_TERMS = Object.freeze({
  JP: ['1', '2', '3', '5', '6', '10', '12', '15', '18', '20', '24'],
});

// https://developer.squareup.com/reference/sdks/web/payments/enums/CardType
export const WEB_PAYMENTS_SDK_CARD_TYPES = Object.freeze({
  CREDIT: 'CREDIT',
  DEBIT: 'DEBIT',
  UNKNOWN_CARD_TYPE: 'UNKNOWN_CARD_TYPE',
});
